window.addEventListener('load', () => {
  function hideMoastProducts() {
    const shadowRoot = document.querySelector('moast-player')?.shadowRoot;
    if (!shadowRoot) return false;

    const elements = shadowRoot.querySelectorAll('moast-products');
    if (elements.length === 0) return false;

    elements.forEach((el) => (el.style.display = 'none'));
    return true;
  }

  hideMoastProducts();

  const observer = new MutationObserver(() => hideMoastProducts());

  const moastPlayer = document.querySelector('moast-player');
  if (moastPlayer?.shadowRoot) {
    observer.observe(moastPlayer.shadowRoot, {
      childList: true,
      subtree: true,
    });
  }
});
